import React, { useState, useEffect, useRef } from "react";
import $ from "jquery";
import "datatables.net";
import "datatables.net-dt/css/jquery.dataTables.css";
import SideMenu from "./SideMenu";
import Header from "./Header";
import Footer from "./Footer";
import axios from "axios";
import { Table, Thead, Tbody, Tr, Th, Td } from "react-super-responsive-table";
import "react-super-responsive-table/dist/SuperResponsiveTableStyle.css";
import "bootstrap/dist/css/bootstrap.min.css";
import Swal from "sweetalert2";

import {
  saveAdditionalPermit,
  getAllPermitsByCorePermitID,
  ApproveRejectPermit,
} from "../Utilities/URLCONSTANTS";
import { Button, Modal } from "react-bootstrap";
import {
  corePermitInitialsConst,
  ElevatedWork,
  EmergencyConst,
  HazardIdentConst,
  Mitigation,
  RoofAccessConstant,
  FallRescueConstant,
  CommentsConst,
  rWorkPermit,
  SignatureConstant,
} from "../Utilities/criticalElevated-JSON";
import {
  USER_PROFILE,
  retrieveData,
  COREPERMIT_MOBILE_NUMBER,
  checkForEmptyValue,
} from "../Utils";
// import moment from "moment";
import Emergency from "../components/criticalElevatedWork/Emergency";
import ScopeOfElevatedWork from "../components/criticalElevatedWork/ScopeOfElevatedWork";
import FallRescue from "../components/criticalElevatedWork/FallRescue";
import CoreRoofAccess from "../components/criticalElevatedWork/RoofAccess";
import HazardIdentific from "../components/criticalElevatedWork/HazardIdentification";
import HazardMitigation from "../components/criticalElevatedWork/HazardMitigation";
import ReviedWork from "../components/criticalElevatedWork/ReviedWork";
import Signatures from "../components/criticalElevatedWork/Signatures";
import AdditionalComments from "../components/criticalElevatedWork/AdditionalComments";
import { useNavigate, useSearchParams } from "react-router-dom";
import arrowIcon from "../images/Left-arrow.png";
import Accordion from "../Accordation/Accordian";
//loader img
import Loader_Bulk from "../Utilities/Loader_Bulk";

//Approve
import Approved from "../images/Approved.png";
// import CorePermitInputFields from "../components/corePermitM2/corePermitInputFields";
import CorePermitInputFields from "../components/criticalElevatedWork/corePermitInputFields";

const CriticalElevated = (props) => {
  const [permitInitials, setPermitInitials] = useState(corePermitInitialsConst);
  const [emergency, setEmergency] = useState(EmergencyConst);
  const [scopeOfElevatedWork, setScopeOfElevatedWork] = useState(ElevatedWork);
  const [hazardIdentification, setHazardIdentification] =
    useState(HazardIdentConst);
  const [hazardMitigation, setHazardMitigation] = useState(Mitigation);
  const [roofAccess, setRoofAccess] = useState(RoofAccessConstant);
  const [fallRescue, setFallRescue] = useState(FallRescueConstant);
  const [additionalComments, setAdditionalComments] = useState(CommentsConst);
  const [terms, setTerms] = useState(rWorkPermit);
  const [signature, setSignature] = useState(SignatureConstant);
  const [serverRecordId, setServerRecordId] = useState(null);
  const [finalSubmit, setFinalSubmit] = useState(false);
  //Approve
  const [showApproved, setShowApproved] = useState(false);
  const [status, setStatus] = useState("");
  const [apiStatus, setApiStatus] = useState("");
  const [showModal, setShowModal] = useState(false);

  //loader
  const [isLoading, setIsLoading] = useState(false);
  const [loaderImage, setLoaderImage] = useState(
    require("../images/rmloader.gif")
  );

  //Reject
  const [showReject, setShowReject] = useState(false);
  const [remarks, setRemarks] = useState("");
  const [isEdit, setIsEdit] = useState(false);
  const [searchParams, setSearchParams] = useSearchParams();
  const addtionalpermitstatus = searchParams.get("permitstatus");

  // validation
  const [openAccordion, setOpenAccordion] = useState(null);
  const [emergencyToggleOn, setEmergencyToggleOn] = useState(true);
  const [scopOfElevatedToggleOn, setScopOfElevatedToggleOn] = useState(true);
  const [hazardIdentificationToggleOn, setHazardIdentificationToggleOn] = useState(true);
  const [hazardMitigationToggleOn, setHazardMitigationToggleOn] = useState(true);
  const [roofAccessToggleOn, setRoofAccessToggleOn] = useState(true);
  const [roofRescueToggleOn, setRoofRescueToggleOn] = useState(true);
  const [additionalToggleOn, setAdditionalToggleOn] = useState(true);
  const [reviewdToggleOn, setReviewdToggleOn] = useState(true);
  const [sighnToggleOn, setSighnToggleOn] = useState(true);


  const navigate = useNavigate();
  // api
  const handleBackButtonClick = () => {
    navigate(-1);
  };

  //Toggle
  const handleToggleItems = () => {
    setEmergencyToggleOn(!emergencyToggleOn)
  }
  const handleScopeToggleItems = () => {
    setScopOfElevatedToggleOn(!scopOfElevatedToggleOn)
  }

  const handleHazardIdentificationToggleItems = () => {
    setHazardIdentificationToggleOn(!hazardIdentificationToggleOn)
  }
  const handleHazardMitigationToggleItems = () => {
    setHazardMitigationToggleOn(!hazardMitigationToggleOn);
  }

  const handleRoofAccessToggleItems = () => {
    setRoofAccessToggleOn(!roofAccessToggleOn)
  }

  const handleRescueToggleItems = () => {
    setRoofRescueToggleOn(!roofRescueToggleOn)
  }

  const handleAdditionalToggleItems = () => {
    setAdditionalToggleOn(!additionalToggleOn)
  }

  const handleReviewdToggleItems = () => {
    setReviewdToggleOn(!reviewdToggleOn)
  }

  const handleSignatureToggleItems = () => {
    setSighnToggleOn(!sighnToggleOn)
  }

  useEffect(() => {
    getFormData();
    return () => { };
  }, []);

  const resetForm = () => {
    setPermitInitials(corePermitInitialsConst);
    setEmergency(EmergencyConst);
    setScopeOfElevatedWork(ElevatedWork);
    setHazardIdentification(HazardIdentConst);
    setHazardMitigation(Mitigation);
    setRoofAccess(RoofAccessConstant);
    setFallRescue(FallRescueConstant);
    setAdditionalComments(CommentsConst);
    setTerms(rWorkPermit);
    setSignature(SignatureConstant);
    setFinalSubmit(false);
  };

  useEffect(() => {
    const search = props.location; // returns the URL query String
    const params = new URLSearchParams(search);
    const IdFromURLwithEDit = searchParams.get("corePermitId");

    var IdFromURL;
    var isEdit = "true";
    var additional_permit_id;
    if (IdFromURLwithEDit == null) {
    } else {
      IdFromURL = IdFromURLwithEDit.toString().split("/")[0];
      isEdit = IdFromURLwithEDit.toString().split("/")[1];
      additional_permit_id = IdFromURLwithEDit.toString().split("/")[2];
    }

    // alert("IdFromURL"+IdFromURL);
    setIsEdit(isEdit);
    // alert(isEdit);
    getFormData(
      IdFromURL != undefined && IdFromURL != null && IdFromURL != ""
        ? IdFromURL
        : 0,
      additional_permit_id != undefined &&
        additional_permit_id != null &&
        additional_permit_id != ""
        ? additional_permit_id
        : 0
    );
    return () => { };
  }, [isEdit]);
  async function filterArray(array, keyName, searchText) {
    console.log("responseFFFF", keyName + "---" + searchText);

    var filteredArray = [];

    for (let i = 0; i < array.length; i++) {
      if (array[i].permitID.toString() === searchText.toString()) {
        filteredArray.push(array[i]);
        break;
      }
    }
    console.log("Myfilter array::", filteredArray);
    return filteredArray[0];
  }

  const getFormData = async (id, additional_permit_id) => {
    console.log(id);
    try {
      // First, retrieve data from sessionStorage if needed
      const dataFromStore = sessionStorage.getItem(COREPERMIT_MOBILE_NUMBER);
      // Make an API request using Axios to get permits by core permit ID
      const vendormobileNumber = sessionStorage.getItem(
        "COREPERMIT_MOBILE_NUMBER"
      );
      const vendorname = sessionStorage.getItem("COREPERMIT_VENDOR_NAME");
      const PermitID = sessionStorage.getItem("CorePermitM2_PERMITID");
      const response = await axios.post(getAllPermitsByCorePermitID, {
        mobileNumber: vendormobileNumber,
        name: vendorname,
        PermitID: addtionalpermitstatus == "Submit" ? PermitID : id, //PermitID
      });
      console.log("id:::", dataFromStore);
      console.log("response data:", response.data);
      if (addtionalpermitstatus != "Submit") {
        // Check if the response contains data
        if (response.data && response.data.response) {
          const elevated =
            response?.data?.response?.critical_elevated_permit || [];
          const dataLast =
            elevated.find((item) => item.permitID === additional_permit_id)
              ?.permitObject || null;
          console.log("filteredArray checking", JSON.stringify(dataLast));

          if (dataLast) {
            setPermitInitials(
              dataLast?.permitInitials
                ? dataLast?.permitInitials
                : permitInitials
            );
            setEmergency(dataLast?.emergency ? dataLast?.emergency : emergency);
            setScopeOfElevatedWork(
              dataLast?.scopeOfElevatedWork
                ? dataLast?.scopeOfElevatedWork
                : scopeOfElevatedWork
            );
            setHazardIdentification(
              dataLast?.hazardIdentification
                ? dataLast?.hazardIdentification
                : hazardIdentification
            );
            setHazardMitigation(
              dataLast?.hazardMitigation
                ? dataLast?.hazardMitigation
                : hazardMitigation
            );
            setRoofAccess(
              dataLast?.roofAccess ? dataLast?.roofAccess : roofAccess
            );
            setFallRescue(
              dataLast?.fallRescue ? dataLast?.fallRescue : fallRescue
            );
            setAdditionalComments(
              dataLast?.additionalComments
                ? dataLast?.additionalComments
                : additionalComments
            );
            setTerms(dataLast?.terms ? dataLast?.terms : terms);
            setSignature(dataLast?.signature ? dataLast?.signature : signature);

            setServerRecordId(
              elevated.find((item) => item.permitID === additional_permit_id)
                ?.permitID || "0"
            );
            //Toggles
            setEmergencyToggleOn(dataLast.emergencyToggleOn !== undefined ? dataLast.emergencyToggleOn : emergencyToggleOn);
            setScopOfElevatedToggleOn(dataLast.scopOfElevatedToggleOn !== undefined ? dataLast.scopOfElevatedToggleOn : scopOfElevatedToggleOn);
            setHazardIdentificationToggleOn(dataLast.hazardIdentificationToggleOn !== undefined ? dataLast.hazardIdentificationToggleOn : hazardIdentificationToggleOn);
            setHazardMitigationToggleOn(dataLast.hazardMitigationToggleOn !== undefined ? dataLast.hazardMitigationToggleOn : hazardMitigationToggleOn);
            setRoofAccessToggleOn(dataLast.roofAccessToggleOn !== undefined ? dataLast.roofAccessToggleOn : roofAccessToggleOn);
            setRoofRescueToggleOn(dataLast.roofRescueToggleOn !== undefined ? dataLast.roofRescueToggleOn : roofRescueToggleOn);
            setAdditionalToggleOn(dataLast.additionalToggleOn !== undefined ? dataLast.additionalToggleOn : additionalToggleOn);
            setReviewdToggleOn(dataLast.reviewdToggleOn !== undefined ? dataLast.reviewdToggleOn : reviewdToggleOn);
            setSighnToggleOn(dataLast.sighnToggleOn !== undefined ? dataLast.sighnToggleOn : sighnToggleOn);

          }
        } else {
          console.log("Response data is missing or invalid.");
        }
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  const handleApproved = async (e) => {
    e.preventDefault();
    setStatus("");
    setShowApproved(true);
  };
  const handleAprrovedOk = async (e) => {
    console.log(e, "handleOk");
    const ApproveData = {
      permitName: "criticalElevatedPermit",
      corePermitID: "5",
      additionalPermitID: "11",
      status: "Approved",
      //"remarks": "remarks"
    };
    const response = await axios.post(ApproveRejectPermit, ApproveData);
    console.log("responce", response);
    if (response.data.statusCode !== "200") {
      setApiStatus(response.data.status);
      console.log("API throwing error");
    }
    setShowApproved(false);
    console.log(status);
  };


  const handleReject = (e) => {
    e.preventDefault();
    setRemarks("");
    setShowReject(true);
  };
  const handleRejectOk = async (e) => {
    console.log(e, "handleRejectOk");

    const RejectData = {
      permitName: "cranePermit",
      corePermitID: "5",
      additionalPermitID: "7",
      status: "Rejected",
      remarks: remarks,
    };
    const response = await axios.post(ApproveRejectPermit, RejectData);
    console.log("responce", response);
    if (response.data.statusCode !== "200") {
      setApiStatus(response.data.status);
      //console.log("API throwing error");
    }
    setShowReject(false);
    console.log(status);
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    const hazardList = hazardIdentification.hazard.filter(
      (item) => item.checked
    );
    const hazardChecking = hazardList.length >= 1 ? "true" : "";

    const workAccessList = hazardMitigation.workAccess.filter(
      (item) => item.description
    );
    const workAccessChecking = workAccessList.length >= 1 ? "true" : "";

    const slopeList = roofAccess.slopeType.list.filter((item) => item.checked);
    const slopeListchecked = slopeList.length >= 1 ? "true" : "";

    const fallListcheck = fallRescue.fallList.filter(
      (item) => item.description
    ); //  .fallList.filter(item => item.description);
    const fallListchecked = fallListcheck.length >= 1 ? "true" : "";

    const termsList = terms.list1.filter((item) => item.description);
    const termsListchecked = termsList.length >= 1 ? "true" : "";

    const datesList = signature.dates[0].fromDate;
    const datesList1 = signature.dates[0].toDate;
    const datesListchecked =
      datesList != null &&
        datesList != "" &&
        datesList1 != null &&
        datesList1 != ""
        ? "true"
        : "";


    var valuesToCheck = [];
    if (emergencyToggleOn) {
      const updatedValues = [...valuesToCheck];
      updatedValues[0] = {
        ...updatedValues[0],
        emergency: {
          phoneNumber: emergency.phoneNumber,
        },
      };
      console.log("fixed values", valuesToCheck);
      valuesToCheck = [...updatedValues];
    }


    if (scopOfElevatedToggleOn) {
      const updatedValues = [...valuesToCheck];
      updatedValues[0] = {
        ...updatedValues[0],
        scopeOfElevatedWork: {
          Company: scopeOfElevatedWork.Company,
        },
      };
      valuesToCheck = [...updatedValues];
    }

    if (hazardIdentificationToggleOn) {
      const updatedValues = [...valuesToCheck];
      updatedValues[0] = {
        ...updatedValues[0],
        hazardIdentification: {
          hazard: hazardChecking,
        },
      };
      valuesToCheck = [...updatedValues];
    }


    if (hazardMitigationToggleOn) {
      const updatedValues = [...valuesToCheck];
      updatedValues[0] = {
        ...updatedValues[0],
        hazardMitigation: {
          workAccess: workAccessChecking,
        },
      };
      valuesToCheck = [...updatedValues];
    }

    if (roofAccessToggleOn) {
      const updatedValues = [...valuesToCheck];
      updatedValues[0] = {
        ...updatedValues[0],
        roofAccess: {
          slopeType: slopeListchecked,
        },
      };
      valuesToCheck = [...updatedValues];
    }

    if (roofRescueToggleOn) {
      const updatedValues = [...valuesToCheck];
      updatedValues[0] = {
        ...updatedValues[0],
        fallRescue: {
          fallList: fallListchecked,
        },
      };
      valuesToCheck = [...updatedValues];
    }


    if (additionalToggleOn) {
      const updatedValues = [...valuesToCheck];
      updatedValues[0] = {
        ...updatedValues[0],
        additionalComments: {
          description: additionalComments.description,
        },
      };
      valuesToCheck = [...updatedValues];
    }


    if (reviewdToggleOn) {
      const updatedValues = [...valuesToCheck];
      updatedValues[0] = {
        ...updatedValues[0],
        terms: {
          list1: termsListchecked,
        },
      };
      valuesToCheck = [...updatedValues];
    }

    if (sighnToggleOn) {
      const updatedValues = [...valuesToCheck];
      updatedValues[0] = {
        ...updatedValues[0],
        signature: {
          dates: datesListchecked,
        },
      };
      valuesToCheck = [...updatedValues];
    }

    let allCasesValid = true;
    for (const item of valuesToCheck) {
      const returnKey = checkForEmptyValue(item);
      // alert("returnKey   " + returnKey)
      switch (returnKey) {
        case "emergency":
          if (emergencyToggleOn) {
            Swal.fire({
              icon: "warning",
              text: "Fill the Emergency Data",
              confirmButtonColor: "#d33",
            });
            allCasesValid = false;
          }
          break;

        case "scopeOfElevatedWork":
          if (scopOfElevatedToggleOn) {
            Swal.fire({
              icon: "warning",
              text: "Please Fill The Scope Of Elevated Work Data",
              confirmButtonColor: "#d33",
            });
            allCasesValid = false;
          }
          break;

        case "hazardIdentification":
          if (hazardIdentificationToggleOn) {
            Swal.fire({
              icon: "warning",
              text: "Please Fill The Hazard Identification Data",
              confirmButtonColor: "#d33",
            });
            allCasesValid = false;
          }
          break;

        case "hazardMitigation":
          if (hazardMitigationToggleOn) {
            Swal.fire({
              icon: "warning",
              text: "Please Fill The Hazard Mitigation Data",
              confirmButtonColor: "#d33",
            });
            allCasesValid = false;
          }
          break;

        case "roofAccess":
          if (roofAccessToggleOn) {
            Swal.fire({
              icon: "warning",
              text: "Please Fill The Roof Access Data",
              confirmButtonColor: "#d33",
            });
            allCasesValid = false;
          }
          break;

        case "fallRescue":
          if (roofRescueToggleOn) {
            Swal.fire({
              icon: "warning",
              text: "Please Fill The Fall Rescue Data",
              confirmButtonColor: "#d33",
            });
            allCasesValid = false;
          }
          break;

        case "additionalComments":
          if (additionalToggleOn) {
            Swal.fire({
              icon: "warning",
              text: "Please Fill The Additional Comments Data",
              confirmButtonColor: "#d33",
            });
            allCasesValid = false;
          }
          break;

        case "terms":
          if (reviewdToggleOn) {
            Swal.fire({
              icon: "warning",
              text: "Please Fill The Terms Data",
              confirmButtonColor: "#d33",
            });
            allCasesValid = false;
          }
          break;

        case "signature":
          if (sighnToggleOn) {
            Swal.fire({
              icon: "warning",
              text: "Please Fill The Signature Data",
              confirmButtonColor: "#d33",
            });
            allCasesValid = false;
          }
          break;
      }

    }
    if (allCasesValid) {
      var vendorname = sessionStorage.getItem("COREPERMIT_VENDOR_NAME");
      var vendormobileNumber = sessionStorage.getItem(
        "COREPERMIT_MOBILE_NUMBER"
      );
      var corePermitID = sessionStorage.getItem("CorePermitM2_PERMITID");
      const dataFromStore = await retrieveData(USER_PROFILE);
      const userProfileData = {
        id: serverRecordId ? serverRecordId : "0",
        mobileNumber: vendormobileNumber,
        name: vendorname,
        corePermitID: corePermitID, //"12345",
        additionalPermitName: "critical_elevated_permit",
      };

      const finalJson = {
        request: {
          permitInitials,
          emergency,
          scopeOfElevatedWork,
          hazardIdentification,
          hazardMitigation,
          roofAccess,
          fallRescue,
          additionalComments,
          terms,
          signature,
          scopOfElevatedToggleOn,
          emergencyToggleOn,
          hazardIdentificationToggleOn,
          hazardMitigationToggleOn,
          roofAccessToggleOn,
          roofRescueToggleOn,
          additionalToggleOn,
          reviewdToggleOn,
          sighnToggleOn,
        },
        ...userProfileData,
      };
      try {
        setIsLoading(true);
        console.log(finalJson, "finalJson***");
        const response = await axios.post(saveAdditionalPermit, finalJson);
        console.log(response.status, "sdmnhba");
        console.log("response", response);
        if (response.status == 200 && response) {
          setShowModal(true);
          setIsLoading(false);
          resetForm(); // Reset form fields
        }
      } catch (error) {
        console.log(error);
        setIsLoading(false);
      }
    }
  };

  return (
    <body id="page-top">

      {finalSubmit ? (
        <>
          <h3>Form Submitted Successfully!!!</h3>
        </>
      ) : (
        <>
          <div id="wrapper">

            <div
              id="content-wrapper"
              className="d-flex flex-column"
              style={{ backgroundColor: "white" }}
            >
              <div id="content">

                <div
                  className="row"
                  style={{ backgroundColor: "var(--theme-bg-primary-color)", padding: "7px" }}
                >
                  <div className="col-md-3 col-12">
                    <img
                      src={arrowIcon}
                      onClick={handleBackButtonClick}
                      alt="Back"
                      style={{
                        width: 40,
                        height: 30,
                        padding: 5,
                        verticalAlign: "middle",
                      }}
                    />
                    <span
                      style={{
                        fontSize: 20,
                        color: "white",
                        marginLeft: 10,
                        marginTop: 12,
                      }}
                    >
                      Critical Evaluated Permit
                    </span>
                  </div>
                </div>
                <div>
                  <div className="container-fluid">
                    <div className="d-flex justify-content-between"></div>
                    <div>
                      <form className="CriticalElevated-form">
                        <style>{`
                            .form-check {
                            padding-left: 1.5rem !important;
                            }
                            .form-check-input {
                            margin-left: -1.25em !important;
                            }
                            .form-check .form-check-input{
                              margin-left: -1.25em !important;
                            }
                        `}</style>
                        <CorePermitInputFields
                          data={permitInitials}
                          setPermitInitials={setPermitInitials}
                          editable={false}
                        />
                        <Accordion
                          title="EMERGENCY"
                          bgColor="#DF3A1C"
                          handleToggle={handleToggleItems}
                          isToggled={emergencyToggleOn}
                          openAccordion={openAccordion}
                          setOpenAccordion={setOpenAccordion}
                          index="emergency"
                          content={
                            <Emergency
                              data={emergency}
                              emergencyToggleOn={emergencyToggleOn}
                              setEmergency={setEmergency}
                              onDataChange={(data) => {
                                setEmergency(data);
                              }}
                            />
                          }
                          bordercolor="#DF3A1C"
                          showToggle={true}

                        />
                        <Accordion
                          title="SCOPE OF ELEVATED WORK"
                          bgColor="#262828"
                          handleToggle={handleScopeToggleItems}
                          isToggled={scopOfElevatedToggleOn}
                          openAccordion={openAccordion}
                          setOpenAccordion={setOpenAccordion}
                          index="scopeOfElevatedWork"
                          content={
                            <ScopeOfElevatedWork
                              data={scopeOfElevatedWork}
                              scopOfElevatedToggleOn={scopOfElevatedToggleOn}
                              setScopeOfElevatedWork={setScopeOfElevatedWork}
                              onDataChange={(data) => {
                                setScopeOfElevatedWork(data);
                              }}
                            />
                          }
                          bordercolor="#262828"
                          showToggle={true}

                        />
                        <Accordion
                          title="HAZARD IDENTIFICATION"
                          bgColor="#566060"
                          handleToggle={handleHazardIdentificationToggleItems}
                          isToggled={hazardIdentificationToggleOn}
                          openAccordion={openAccordion}
                          setOpenAccordion={setOpenAccordion}
                          index="hazardIdentification"
                          content={
                            <HazardIdentific
                              data={hazardIdentification}
                              hazardIdentificationToggleOn={hazardIdentificationToggleOn}
                              setHazardIdentification={setHazardIdentification}
                              onDataChange={(data) =>
                                setHazardIdentification(data)
                              }
                            />
                          }
                          bordercolor="#566060"
                          showToggle={true}

                        />
                        <Accordion
                          title="HAZARD MITIGATION"
                          bgColor="#DF3A1C"
                          handleToggle={handleHazardMitigationToggleItems}
                          isToggled={hazardMitigationToggleOn}
                          openAccordion={openAccordion}
                          setOpenAccordion={setOpenAccordion}
                          index="hazardMitigation"
                          content={
                            <HazardMitigation
                              data={hazardMitigation}
                              hazardMitigationToggleOn={hazardMitigationToggleOn}
                              setHazardMitigation={setHazardMitigation}
                              onDataChange={(data) =>
                                setHazardIdentification(data)
                              }
                            />
                          }
                          bordercolor="#DF3A1C"
                          showToggle={true}

                        />
                        <Accordion
                          title="ROOF ACCESS"
                          bgColor="#FF7E51"
                          handleToggle={handleRoofAccessToggleItems}
                          isToggled={roofAccessToggleOn}
                          openAccordion={openAccordion}
                          setOpenAccordion={setOpenAccordion}
                          index="roofAccess"
                          content={
                            <CoreRoofAccess
                              data={roofAccess}
                              roofAccessToggleOn={roofAccessToggleOn}
                              setRoofAccess={setRoofAccess}
                              onDataChange={(data) => setRoofAccess(data)}
                            />
                          }
                          bordercolor="#FF7E51"
                          showToggle={true}

                        />
                        <Accordion
                          title="FALL RESCUE"
                          bgColor="#34B85F"
                          handleToggle={handleRescueToggleItems}
                          isToggled={roofRescueToggleOn}
                          openAccordion={openAccordion}
                          setOpenAccordion={setOpenAccordion}
                          index="fallRescue"
                          content={
                            <FallRescue
                              data={fallRescue}
                              roofRescueToggleOn={roofRescueToggleOn}
                              setFallRescue={setFallRescue}
                              onDataChange={(val) => {
                                setFallRescue(val);
                              }}
                            />
                          }
                          bordercolor="#34B85F"
                          showToggle={true}

                        />
                        <Accordion
                          title="ADDITIONAL COMMENTS & MODIFICATIONS"
                          bgColor="#566060"
                          handleToggle={handleAdditionalToggleItems}
                          isToggled={additionalToggleOn}
                          openAccordion={openAccordion}
                          setOpenAccordion={setOpenAccordion}
                          index="additionalComments"
                          content={
                            <AdditionalComments
                              data={additionalComments}
                              additionalToggleOn={additionalToggleOn}
                              setAdditionalComments={setAdditionalComments}
                              onDataChange={(data) =>
                                setAdditionalComments(data)
                              }
                            />
                          }
                          bordercolor="#566060"
                          showToggle={true}

                        />

                        <Accordion
                          title={
                            <span>
                              I HAVE REVIEWED AND UNDERSTOOD...
                              <span className="required">
                                {" "}
                                *
                                <span
                                  className="text-white"
                                  style={{ fontSize: "12px" }}
                                >
                                  {" "}
                                  (Fill Required Fields)
                                </span>
                              </span>
                            </span>
                          }
                          bgColor="#A1A2A5"
                          handleToggle={handleReviewdToggleItems}
                          isToggled={reviewdToggleOn}
                          openAccordion={openAccordion}
                          setOpenAccordion={setOpenAccordion}
                          index="ihaveReviewed"
                          content={
                            <ReviedWork
                              data={terms}
                              reviewdToggleOn={reviewdToggleOn}
                              setTerms={setTerms}
                              onDataChange={(data) => {
                                setTerms(data);
                              }}
                            />
                          }
                          bordercolor="#A1A2A5"
                          showToggle={true}

                        />

                        <Accordion
                          title="SIGNATURES"
                          bgColor="#2C2E35"
                          handleToggle={handleSignatureToggleItems}
                          isToggled={sighnToggleOn}
                          openAccordion={openAccordion}
                          setOpenAccordion={setOpenAccordion}
                          index="signatures"
                          content={
                            <Signatures
                              data={signature}
                              sighnToggleOn={sighnToggleOn}
                              setSignature={setSignature}
                              onDataChange={(data) => setSignature(data)}
                            />
                          }
                          bordercolor="#2C2E35"
                          showToggle={true}

                        />


                        <div>
                          {isEdit.toString() == "true" && (
                            <button
                              type="button"
                              className={`d-flex justify-content-center align-items-center w-100 btn btn-light text-white  ${"custom-rounded"}`}
                              style={{
                                height: "50px",
                                // backgroundColor: "#007AFF",
                                backgroundColor: "var(--theme-bg-primary-color)",
                                color: "white",
                                border: "none",
                              }}
                              onClick={handleSubmit}
                            >
                              Submit
                            </button>
                          )}
                          <Modal
                            show={showModal}
                            onHide={() => setShowModal(false)}
                            size="sm"
                            id="nsmodel"
                            className="ppopup"
                          >
                            <Modal.Body>
                              <div>
                                <div className="row">
                                  <div>
                                    <span
                                      style={{
                                        textAlign: "center",
                                        display: "flex",
                                        justifyContent: "center",
                                        alignItems: "center",
                                        height: "15vh",
                                      }}
                                    >
                                      <img
                                        src={Approved}
                                        alt="save"
                                        className="popupicons"
                                      />
                                    </span>
                                  </div>
                                </div>
                                <div>
                                  <p
                                    style={{
                                      textAlign: "center",
                                      display: "flex",
                                      justifyContent: "center",
                                      alignItems: "center",
                                      height: "3vh",
                                    }}
                                  >
                                    <h5>Critical Elevated sent for Approval</h5>
                                  </p>
                                </div>
                                <div>
                                  <p
                                    style={{
                                      textAlign: "center",
                                      justifyContent: "center",
                                      alignItems: "center",
                                      margin: "0px",
                                    }}
                                  >
                                    <Button
                                      variant="primary"
                                      className={`d-flex justify-content-center align-items-center w-100 btn btn-light text-white mb-2  ${"custom-rounded"}`}
                                      style={{
                                        // backgroundColor: "#007AFF",
                                        backgroundColor: "var(--theme-bg-primary-color)",
                                        color: "white",
                                        border: "none",
                                      }}
                                      onClick={() => {
                                        handleBackButtonClick();
                                        setShowModal(false);
                                      }}
                                    >
                                      Ok
                                    </Button>
                                  </p>
                                </div>
                              </div>
                            </Modal.Body>


                          </Modal>

                        </div>
                        <div>
                          <Modal
                            show={showApproved}
                            onHide={() => setShowApproved(false)}
                            size="sm"
                            centered
                          >
                            <Modal.Body>
                              <p
                                style={{
                                  textAlign: "center",
                                  marginBottom: "20px",
                                }}
                              >
                                <h3>Permit Status</h3>
                              </p>
                              <div className="form-group">
                                <label htmlFor="name" class="centered-text">
                                  <h6>Permit Approved Successfully</h6>
                                </label>

                              </div>
                            </Modal.Body>
                            <Modal.Footer style={{ border: "0" }}>
                              <div
                                className="d-flex"
                                style={{
                                  width: "100%",
                                  justifyContent: "center",
                                }}
                              >
                                <Button
                                  variant="primary btn-lg w-100"
                                  onClick={handleAprrovedOk}
                                >
                                  Ok
                                </Button>
                              </div>
                              <span>{apiStatus}</span>
                            </Modal.Footer>
                          </Modal>
                        </div>

                        <div>
                          <Modal
                            show={showReject}
                            onHide={() => setShowReject(false)}
                            size="sm"
                            centered
                          >
                            <Modal.Body>
                              <p
                                style={{
                                  textAlign: "center",
                                  display: "flex",
                                  justifyContent: "center",
                                  alignItems: "center",
                                  height: "15vh",
                                }}
                              >
                                <h3> Are you sure want to Reject?</h3>
                              </p>
                              <div className="form-group">
                                <label htmlFor="name">Reason:</label>
                                <input
                                  type="text"
                                  className="form-control"
                                  id="name"
                                  placeholder="Reason for Rejection"
                                  value={remarks}
                                  onChange={(e) => {
                                    setRemarks(e.target.value);
                                  }}
                                />
                              </div>
                            </Modal.Body>
                            <Modal.Footer style={{ border: "0" }}>
                              <div
                                className="d-flex"
                                style={{
                                  width: "100%",
                                  justifyContent: "center",
                                }}
                              >
                                <Button
                                  variant="primary btn-lg w-100"
                                  onClick={handleRejectOk}
                                >
                                  Ok
                                </Button>
                              </div>
                            </Modal.Footer>
                          </Modal>
                        </div>
                      </form>

                    </div>
                  </div>
                  {/*  Clseout end */}
                </div>
                {/* <Footer /> */}
                {/* ... End of Footer...  */}
              </div>
            </div>
            {/*  <!-- End of Page Wrapper -->

                    <!-- Scroll to Top Button--> */}
            <a className="scroll-to-top rounded" href="#page-top">
              <i className="fas fa-angle-up"></i>
            </a>
            {/*  <!-- Logout Modal--> */}
            {/* <Logout /> */}
          </div>
        </>
      )}
      {isLoading && (
        <Loader_Bulk
          loading={isLoading}
          // message={"Fetching Data. Please Wait..!"}
          message={"Processing your submission. Please wait..."}
          loderimage={loaderImage}
        />
      )}
    </body>
  );
};

export default CriticalElevated;
